import { useEffect, useState } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import useLanguageChange from "../../../../hooks/useLanguageChange";
import { PublicVariables } from "../../../../constants/PublicVariables";
import { getPolicyByLanguage } from "../../../../shared/utility";
import CenterModal from "../../../UI/Modal/CenterModal";
import Checkbox from "../../../UI/Checkbox/Checkbox";

const PrivacyPolicy = ({ handlePrivacyPolicyAgreed }) => {
    const { privacyPolicyData } = useSelector((state) => state.onLoadData);
    const ldFlags = useFlags();

    const privacyPolicyBasedOnSelectedLanguage = getPolicyByLanguage(
        PublicVariables.currentLanguageObj.languageCode,
        privacyPolicyData.privacyPolicies
    );

    const [privacyChecked, setPrivacyChecked] = useState(false);

    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change*/
    const localisedValues = useLanguageChange();

    /* handle checkbox value on check uncheck */
    const handleCheckboxOnChange = () => {
        setPrivacyChecked(!privacyChecked);
    };

    useEffect(() => {
        if (ldFlags) {
            setPrivacyChecked(!ldFlags.privacyPolicyUnchecked);
        }
    }, [ldFlags]);

    const header = (
        <>
            <h5 className='modal-title' data-testid='privacyModal'>
                {privacyPolicyBasedOnSelectedLanguage?.linkText}
            </h5>
            <button type='button' className='btn-close' aria-label='Close' onClick={() => handlePrivacyPolicyAgreed(false)}>
                <span className='btn-icon icon-close-light'></span>
            </button>
        </>
    );
    const body = (
        <div className='cms-modal-text'>
            <p
                dangerouslySetInnerHTML={{
                    __html: privacyPolicyBasedOnSelectedLanguage?.popupText
                        ? privacyPolicyBasedOnSelectedLanguage?.popupText
                        : localisedValues["privacy_policy_popup_text_description"],
                }}
            ></p>
        </div>
    );
    const footer = (
        <>
            <div className='privacy-policy-checkbox'>
                <div className='checkbox default-checkbox'>
                    <label>
                        <Checkbox value={privacyChecked} onChange={handleCheckboxOnChange} name='privacyPolicy' id='privacyPolicy' />
                        <span className='for-design'></span>
                        <span className='for-text'>
                            {localisedValues["confirmation_lable"] + " "}
                            <button
                                className='btn default-btn-link padding-0'
                                onClick={() => window.open(privacyPolicyBasedOnSelectedLanguage?.policyUrl, "_blank")}
                            >
                                {privacyPolicyBasedOnSelectedLanguage?.linkText
                                    ? privacyPolicyBasedOnSelectedLanguage?.linkText
                                    : localisedValues["privacy_policy"]}
                            </button>
                        </span>
                    </label>
                </div>
            </div>
            <div className='button-inline more-space button-inline-tb-space d-flex align-items-center'>
                <div className='button'>
                    <button className='btn default-btn-link' onClick={() => handlePrivacyPolicyAgreed(false)}>
                        {localisedValues["decline"]}
                    </button>
                </div>
                <div className='button'>
                    <button className='btn default-btn-primary' onClick={() => handlePrivacyPolicyAgreed(true)} disabled={!privacyChecked}>
                        {localisedValues["agree"]}
                    </button>
                </div>
            </div>
        </>
    );

    return (
        <CenterModal
            showModal={true}
            closeModal={() => handlePrivacyPolicyAgreed(false)}
            modalClass='default-modal mob-bottom-top privacy-policy-modal'
            className='modal-dialog-centered modal-dialog-scrollable'
            bodyClassName='default-custom-scroll'
            footerClassName='privacy-policy-modal-footer'
            header={header}
            body={body}
            footer={footer}
            backdrop={"static"}
        />
    );
};

PrivacyPolicy.propTypes = {
    handlePrivacyPolicyAgreed: PropTypes.func.isRequired,
};

export default PrivacyPolicy;
